import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHome, faUser, faPersonFalling, faChevronRight} from '@fortawesome/free-solid-svg-icons';

import '../css/style.css';
import '../css/bootstrap.css';

function FallDetection() {
  return (
      <div className="FallDetection">
        <div>
          <section id="body-top-menus">
            <div className="container-fluid">
              <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <Link to="/" className="navbar-brand">
                  <img src="img/dh40-logo.png" style={{height: '8vh'}} alt="DeinHaus4.0 Logo - Länger Leben Zuhause Niederbayern" />
                </Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <Link to="/tcflabor" className="nav-link"><FontAwesomeIcon icon={faHome} /> Hausdaten</Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/tcfwatch" className="nav-link"><FontAwesomeIcon icon={faUser} /> Gesundheitsdaten</Link>
                    </li>
                    <li className="nav-item active">
                      <Link to="/falldetection" className="nav-link" style={{color: '#ED7D31'}}><FontAwesomeIcon icon={faPersonFalling} /> Sturzerkennung</Link>
                    </li>
                  </ul>
                </div>
                <img src="img/Ministerium_logo.png" style={{height: '6vh', selfAlign: 'right'}} alt="Förderlogo des Bayerischen Staatsministeriums für Gesundheit und Pflege" />
              </nav>
            </div>
          </section>
          <section id="fallDetection">
            <div class="row">
              <div class="col-2">
              </div>
              <div class="col-8">
                <video src="falldetection/fall_ex_labor2.mp4" style={{height:'80vh', maxWidth:'100%'}} controls>
                  Ihr Browser kann dieses Video nicht wiedergeben.<br/>
                  Dieser Film zeigt eine Demonstration der entwickelten Sturzerkennung.
                </video>
              </div>
              <div class="col-2" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Link to="/falldetectiontwo" className="nav-link" style={{color:'#000000', opacity: '0.5', fontSize: '7vh'}}><FontAwesomeIcon icon={faChevronRight} /></Link>
              </div>
            </div>
          </section>
        </div>
      </div>
  );
}

export default FallDetection;
